var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#DD2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 30.525L58.475 27L44.5 40.975L30.525 27L27 30.525L40.975 44.5L27 58.475L30.525 62L44.5 48.025L58.475 62L62 58.475L48.025 44.5L62 30.525Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.48fc6058.svg";
export { ForwardRef as ReactComponent };